import { render, staticRenderFns } from "./EducationSystem.vue?vue&type=template&id=47e127c7"
import script from "./EducationSystem.vue?vue&type=script&lang=ts"
export * from "./EducationSystem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports